import {
  Divider,
  Box,
  Container,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import Button from "../components/common/Button/Button";
import ContactUsForm from "../components/contactUs/ContactUsForm";
import ContactUsInfo from "../components/contactUs/ContactUsInfo";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import BottomContactUsFormModal from "../components/common/Modal/BottomContactUsFormModal";

function ContactUs() {
  const [ContactUsModal, setContactUsModal] = useState(false);
  const [contactModalType, setContactModalType] = useState("");
  const ContactUsModalToggler = (bool, contactModalType) => {
    setContactUsModal(bool);
    setContactModalType(contactModalType);
  };
  const mobMatch = useMediaQuery("(max-width:600px)");
  const history = useHistory();

  return (
    <Container
      sx={{
        padding: { xs: "24px 16px", sm: "72px 0px" },
        background: "white",
        marginBottom: { xs: "16px", sm: "0px" },
        borderRadius: { xs: "8px", sm: "0px" },
      }}
      disableGutters={true}
    >
      {mobMatch && (
        <Box
          sx={{
            display: {
              xs: "block",
              sm: "none",
            },
            marginTop: "4px",
            marginBottom: "32px",
          }}
        >
          <ArrowBackIcon
            onClick={() => {
              history.goBack();
            }}
            sx={{ color: "primary.main" }}
          />
        </Box>
      )}
      <Box>
        <Typography
          variant={mobMatch ? "h3" : "h2"}
          sx={{
            color: "text.primary",
            fontWeight: { xs: "600", sm: "700" },
            fontSize: { xs: "22px", sm: "32px" },
            lineHeight: { xs: "26px", sm: "36px" },
          }}
        >
          Get in touch
        </Typography>
        <Typography
          sx={{
            color: "#616161",
            fontSize: { xs: "14px", sm: "16px" },
            lineHeight: { xs: "20px", sm: "24px" },
          }}
          variant={mobMatch ? "body2" : "body1"}
        >
          We would love to hear from you.
        </Typography>
        {mobMatch && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              marginTop: "32px",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              size="lg"
              txColor="text.primary"
              bgColor="#F9D548"
              sx={{ height: "48px", width: "100%", boxShadow: "none" }}
              onClick={() => {
                ContactUsModalToggler(true);
              }}
              hoverBg="#F3C04F"
            >
              Contact Us
            </Button>
          </Box>
        )}
        {mobMatch && <Divider sx={{ marginTop: "32px", color: "#D6D6D6" }} />}
      </Box>
      <Box
        sx={{
          marginTop: "32px",
          display: "flex",
          columnGap: "48px",
          height: "100%",
          alignItems: "start",
        }}
      >
        <ContactUsInfo ContactUsModalToggler={ContactUsModalToggler} />
        {!mobMatch && <ContactUsForm />}
      </Box>
      <BottomContactUsFormModal
        open={ContactUsModal}
        toggleDrawer={ContactUsModalToggler}
        contactModalType={contactModalType}
      />
    </Container>
  );
}

export default ContactUs;
